import { SkillForm } from "./_components/SkillForm";

export function SkillEdit() {
  return <SkillForm action="edit" />;
}

export default SkillEdit;
